/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnergyUsageCredentialsRequest } from '../models/EnergyUsageCredentialsRequest';
import type { EnergyUsageCredentialsResponse } from '../models/EnergyUsageCredentialsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnergyUsagesNoAuthRoutesRepository {
  /**
   * Store Credentials
   * Create energy usage credentials.
   * @returns EnergyUsageCredentialsResponse Successful Response
   * @throws ApiError
   */
  public static energyUsagesNoAuthRoutesStoreCredentials({
    token,
    requestBody,
  }: {
    token: string,
    requestBody: Array<EnergyUsageCredentialsRequest>,
  }): CancelablePromise<Array<EnergyUsageCredentialsResponse>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/energy-usages/credentials/invite-token/{token}',
      path: {
        'token': token,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
